/*
 * Copyright (C) 2025 Musarubra US LLC.  All Rights Reserved.
 */

import { WidgetContext } from './widget-context-base';
import { iamLogin } from '../main';
import { iam } from '../iam';
import { WidgetElements } from '../elements/widget-elements-base';

// this context isn't used in production currently but is required in environments using an octa trial account (dev)
export class RecoveryQuestionWidgetContext extends WidgetContext {
  constructor(elements: WidgetElements) {
    super(elements);
  }

  public override initialize() {
    // updatepassword.html page's security question screen, which is sometimes used in dev environments but not in production
    if (iam.settings.debug) console.log('initializing recovery question widget');
    document.getElementById('dont-have-a-mvision').style.display = 'none';
    // suck okta's hidden title out and make it our main header
    const oktaTitle = this.elements.getFormHead();
    if (oktaTitle && oktaTitle.textContent) {
      document.getElementById('main-header').textContent = oktaTitle.textContent;
    }
    iamLogin.showWidget();
    iamLogin.page.showCommonFields(['post-okta']);
    iamLogin.page.initializeCommon();
  }

  public override setInitialFocus() {
    const field = this.elements.getAnswerField();
    if (field && !field.disabled) {
      field.focus();
    }
  }

  public override validateForm() {
    this.elements.getSubmitButton().disabled = this.elements.getAnswerField().value.length === 0;
  }
}
